import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  block-size: 100%;
  position: fixed;
  inset-inline-start: ${spacing(2)};
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`
export const formWithShadow = css`
  margin-block-start: ${spacing(11.5)};
  max-inline-size: ${spacing(100)};

  &::after {
    position: fixed;
    margin-block-start: ${spacing(11)};
    background-color: ${hex2rgba(cssTheme.default.day.everBlack.hex, 0.1)};
    filter: blur(${spacing(4)}); // 32px
    content: '';
    display: block;
    inset-block: 0;
    inset-inline: 0;
    max-inline-size: ${spacing(105)}; // 840px
    z-index: -1;
  }
`
